import React from "react";
import { Link } from "react-router-dom";

const LAB_IMG = "https://images.unsplash.com/photo-1701848055770-effbdb148e15?crop=entropy&cs=srgb&fm=jpg&w=2000&q=80";

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="relative overflow-hidden border-b border-white/5">
        <img src={LAB_IMG} className="absolute inset-0 w-full h-full object-cover opacity-20" alt="" />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-950/60 via-slate-950/90 to-slate-950" />
        <div className="relative max-w-5xl mx-auto px-6 lg:px-10 py-28">
          <div className="label-mono text-cyan-400 mb-4">/ ABOUT NOVAGENIX</div>
          <h1 className="text-5xl md:text-6xl font-medium tracking-tighter max-w-3xl leading-[1]">
            Built by researchers, for researchers.
          </h1>
          <p className="mt-8 text-lg text-slate-300 max-w-2xl leading-relaxed">
            Novagenix Labs was founded with one mission: eliminate variability between research peptide batches.
            Every compound we ship is independently HPLC and MS verified, with a certificate of analysis available on request.
          </p>
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-6 lg:px-10 py-20 grid md:grid-cols-2 gap-12">
        <div>
          <div className="label-mono text-cyan-400 mb-3">/ Standards</div>
          <h2 className="text-3xl font-medium tracking-tight">cGMP-aligned facilities. ISO-quality controls.</h2>
        </div>
        <p className="text-slate-300 leading-relaxed">
          Our synthesis and lyophilization workflows follow current Good Manufacturing Practice principles. Each lot is assigned a unique ID and traceable from raw material through dispatch. We retain reference samples for two years.
        </p>
      </section>

      <section className="max-w-5xl mx-auto px-6 lg:px-10 pb-24">
        <div className="border border-cyan-500/20 p-10">
          <div className="label-mono text-cyan-400 mb-3">/ Get in touch</div>
          <h3 className="text-2xl font-medium">For institutional research inquiries, custom synthesis, or technical questions:</h3>
          <div className="mt-6 flex flex-wrap gap-4">
            <a href="mailto:research@novagenix.com" className="bg-cyan-500 text-slate-950 px-6 py-3 font-semibold" data-testid="contact-email">research@novagenix.com</a>
            <Link to="/shop" className="border border-cyan-500/30 text-cyan-400 px-6 py-3">Browse catalog</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
